// material-ui
import {} from '@mui/material'

// assets

import ViewSupportComponent from 'components/ViewSupportComponent'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid

  function main(subcomponent: any): any {
    return (() => {
      return <ViewSupportComponent />
    })()
  }

  let output_main = main(null)

  return output_main
}
